import { cn } from 'lib/helpers/utility';

import Icon from '../../Icon/Icon';

const Header = ({
  title,
  headButton,
  headerClassName,
  headerCloseIcon = true,
  customHeader,
  prevButton,
  handleClose
}) => {
  return (
    <div className={cn('Modal__head h-[48px]', headerClassName)} data-dd-privacy="allow">
      {customHeader ? (
        customHeader
      ) : (
        <>
          <div className="Modal__head__left">
            {prevButton}
            <h6 className="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-600 lowercase leading-4 text-neutral-800 first-letter:uppercase">
              {title}
            </h6>
            <div className="grow">{headButton}</div>
          </div>
        </>
      )}
      {headerCloseIcon && (
        <div
          className="flex size-[26px] min-w-[26px] cursor-pointer items-center justify-center rounded-[4px] hover:bg-neutral-75"
          onClick={handleClose}>
          <Icon data-qa="close-square-mono" icon="close-linear" className="cursor-pointer" />
        </div>
      )}
    </div>
  );
};

export default Header;
